<template>
    <div :class="{'w-100 announcement-btn': campaign.type === 'announcement'}">
        <a class="request-cp-button" @click="sendAnnouncementEvent" target="_blank" :href="campaign.url" v-if="campaign.type === 'announcement'">
            Register
        </a>
        <button v-else class="request-cp-button" @click="cpReq">
            {{noUpdates ? 'Send Message' : 'Request CrossProm'}}   
        </button>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Button from './Theme/Button'

export default {
    name: 'CpButton',
    components: {Button},
    props: ['campaign','button-location', 'no-updates'],
    computed: {
            ...mapState([
                'user'
            ]),
            ...mapGetters([
                'hasTrial'
            ]),
            cpButtonLocation(){
                if(this.buttonLocation) {
                    return this.buttonLocation
                }
                switch(this.$route.name) {
                    case 'Homepage': 
                        return 'Homepage Grid'
                    case 'campaigns': 
                        return 'Dashboard Favorites'
                    case 'Search': 
                        return 'Advanced Search'
                    case 'Campaign Page':
                        return 'Matching Campaigns'
                }
            }
    },
    methods: {
        sendAnnouncementEvent(){
            this.$ga.event('Announcement', 'Webinar Link Clicked');
            this.$sendMixpanelEvent('Webinar Link Clicked');
        },
        cpReq: function () {
            if(!this.user.uid) {
                return this.$store.commit('TOGGLE_MODAL', ['sign-up', {
                    openedFrom: 'CP Request Button'
                }])
            }

            this.$ga.event('CpRequest', 'Modal Opened', `
                Location:${this.cpButtonLocation},
                Campaign:${this.campaign.title},
                IsCounterOffer:false
            `)

            this.$sendMixpanelEvent('Request Crossprom Modal Opened', {
                'Location': this.cpButtonLocation,
                'Campaign Name': this.campaign.title,
                'Is Counter Offer': false
            });

            this.$router.replace({
                query: {
                    ...this.$route.query,
                    project_id: this.campaign.id
                }
            }).catch(() => {})
            this.$store.commit('TOGGLE_MODAL', ['cp-request', true])
        },
    }
}
</script>
<style lang="scss" scoped>
@import  '../assets/scss/variables.scss';
.request-cp-button {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(134.78deg, #0ACF97 5.45%, #0EAAE7 74.58%);
    border-radius: 5px;
    color: #FFFFFF!important;
    transition: all 0.2s ease !important;
    font-size: $p3;
    font-weight: $weight_600;
    width: 100%;
    height: 36px;

    &:hover {
        background: linear-gradient(134.78deg, #0ACF97 5.45%, #0EAAE7 74.58%);
        box-shadow: 0px 13px 27px rgba(14, 170, 231, 0.46);
    }
}

.announcement-btn {
    padding-left: 23px;
    padding-right: 12px;
}

</style>